import React from "react";
import "./Home.css";

const Home = () => {
  return (
    <div className="home">
      <div className="home-hero">
        <div className="hero-image-container">
          <div className="hero-image-placeholder">
            {/* Placeholder for mall image - replace with actual image */}
            <div
              className="hero-image-content"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/the-dubai-mall-amp-waterfall.jpg)`,
              }}
            >
              <div className="hero-overlay-text">DUBAI MALL</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
